import type { AdminRole } from '@/lib/admin/roles';

export type { AdminRole };

export function canViewApiBalance(role: AdminRole): boolean {
  return role === 'dev_admin' || role === 'super_admin';
}

export function canViewProviderRawError(role: AdminRole): boolean {
  return role === 'dev_admin';
}

export function canViewPlatformPrompt(role: AdminRole): boolean {
  return role === 'dev_admin';
}

export function canViewPromptHash(role: AdminRole): boolean {
  return role === 'dev_admin';
}

export function canViewAssetsMetaFull(role: AdminRole): boolean {
  return role === 'dev_admin';
}

export function canManageProviderKeys(role: AdminRole): boolean {
  return role === 'dev_admin';
}

export function canAccessReliabilityConsole(role: AdminRole): boolean {
  return role === 'dev_admin';
}

/** dev_admin 与 super_admin 均可进入商业营运控制台 */
export function canAccessBusinessConsole(role: AdminRole): boolean {
  return role === 'dev_admin' || role === 'super_admin';
}

export function canAccessSupportConsole(role: AdminRole): boolean {
  return role === 'admin';
}

/** 完整营运后台：dev_admin 享有与 super_admin 相同权限 */
export function canAccessLegacyOperations(role: AdminRole): boolean {
  return role === 'dev_admin' || role === 'super_admin';
}

/** 最高管理权限（营运 + raw 诊断） */
export function hasFullAdminAccess(role: AdminRole): boolean {
  return role === 'dev_admin' || role === 'super_admin';
}

export function roleIncludes(allow: AdminRole[], role: AdminRole): boolean {
  return allow.includes(role);
}
